import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Card, CardBody, CardHeader, Container, Row, Col, Button } from 'reactstrap';
import { createHashHistory } from 'history';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import checkBrowser from '../../utils/checkBrowser';
import StatusLoader from '../common/statusLoader';
import routeHelper from '../common/classes/routeHelper';
import Icon from '../common/containers/icon';
import PDF from '../common/pdf/pdf';
const hashHistory = createHashHistory();
const calculatePercentage = function calculatePercentage(timeElapsed) {
  let totalTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
  if (timeElapsed < 10) {
    return Math.floor(2.5 * timeElapsed);
  }
  return Math.floor(timeElapsed / totalTime * 0.75 * 100) + 24;
};
const FormPDFViewer = props => {
  const form = props.form,
    match = props.match,
    notificationActions = props.notificationActions,
    location = props.location,
    formActions = props.formActions;
  const active = form.active,
    error = form.error;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    loadedPercentage = _useState2[0],
    setLoadedPercentage = _useState2[1];
  const handleBack = () => {
    routeHelper.updateURL("".concat(location.pathname.split('/').slice(0, -3).join('/')));
  };
  const handleEdit = () => {
    hashHistory.push("".concat(location.pathname.split('/').slice(0, -1).join('/')));
  };
  useEffect(() => {
    formActions.serverRenderForm(match.params.id);
  }, [formActions, match]);
  useEffect(() => {
    const loadedTime = new Date();
    let timeElapsed = (new Date() - loadedTime) / 1000;
    const loadTime = () => {
      timeElapsed = (new Date() - loadedTime) / 1000;
      setLoadedPercentage(calculatePercentage(timeElapsed));
    };
    const timerInterval = setInterval(loadTime, 100);
    if (active && active.signedURL) {
      clearInterval(timerInterval);
    }
    return () => clearInterval(timerInterval);
  }, [active]);
  const formTitle = '';
  let url = 'invalidURL';
  const docTitle = '';
  if (match.params.id && active && active.signedURL) {
    url = active.signedURL;
  }
  const buttonStyle = {
    marginRight: '5px',
    float: 'left'
  };
  const isMobileOS = checkBrowser.isMobile();
  const showEdit = true;
  const editButton = /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "t-r-edit",
    title: "Edit form",
    onClick: handleEdit,
    style: buttonStyle
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "pencil-alt"
  }), " Edit");
  const header = /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: showEdit && !isMobileOS ? 3 : 2
  }, /*#__PURE__*/React.createElement(Button, {
    className: "t-r-back",
    size: "sm",
    onClick: handleBack,
    style: buttonStyle
  }, "Form Cabinet"), showEdit && !isMobileOS ? editButton : null), /*#__PURE__*/React.createElement(Col, {
    sm: showEdit ? 9 : 10
  }, formTitle)));
  let content = /*#__PURE__*/React.createElement(StatusLoader, {
    percentage: loadedPercentage,
    loaded: !active
  });
  if (active && active.signedURL) {
    content = /*#__PURE__*/React.createElement(PDF, {
      className: "t-doc-report-detail-pdf",
      title: docTitle,
      src: url,
      hideTitleIfMobile: true,
      nativeRenderer: true
    });
  } else if (!form.loading) {
    content = /*#__PURE__*/React.createElement("div", {
      style: {
        paddingLeft: '20px'
      }
    }, /*#__PURE__*/React.createElement("h3", null, "There was a problem rendering this form"), /*#__PURE__*/React.createElement("p", null, "Please try again later"));
  }
  if (error) {
    // print the error msg if possible
    if (error.data && error.data.error_msg) {
      notificationActions.error({
        message: error.data.error_msg,
        id: 'form_render_error'
      });
    }
    // print the whole error
    notificationActions.error({
      message: error
    });
  }
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "formPDFViewer"
  }, /*#__PURE__*/React.createElement(Card, {
    style: {
      height: '1000px'
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading-tight"
  }, header), /*#__PURE__*/React.createElement(CardBody, null, content)));
};
FormPDFViewer.propTypes = {
  form: PropTypes.shape({
    active: PropTypes.shape({
      appCreatorID: PropTypes.string,
      signedURL: PropTypes.string,
      content: PropTypes.shape({}),
      formType: PropTypes.shape({
        name: PropTypes.string
      }),
      formNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      statusName: PropTypes.string
    }),
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    pendingChanges: PropTypes.bool
  }).isRequired,
  formActions: PropTypes.shape({
    serverRenderForm: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};
export { FormPDFViewer as TestFormPDFViewer };
export default entityComposition(FormPDFViewer, ['form'], {}, ['notification']);